import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState, useEffect } from 'react';
import { Droppable, DragDropContext, Draggable } from 'react-beautiful-dnd';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var StrictModeDroppable = function StrictModeDroppable(_a) {
  var _b = _a,
      children = _b.children,
      props = __objRest(_b, ["children"]);

  var _useState = useState(false),
      isMounted = _useState[0],
      setIsMounted = _useState[1];

  useEffect(function () {
    setIsMounted(true);
    return function () {
      setIsMounted(false);
    };
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    /* @__PURE__ */
    React.createElement(Droppable, __spreadValues({}, props), children)
  );
};

function useDragAndDrop(data, options) {
  var _useState2 = useState(),
      items = _useState2[0],
      setItems = _useState2[1];

  var _useState3 = useState((options == null ? void 0 : options.isDragDisabled) || false),
      isDragDisabled = _useState3[0],
      setIsDragDisabled = _useState3[1];

  useEffect(function () {
    if (data) {
      setItems(data);
    }
  }, [data]);

  function reorder(items2, startIndex, endIndex) {
    var orderedItems = _toConsumableArray(items2);

    var _orderedItems$splice = orderedItems.splice(startIndex, 1),
        removed = _orderedItems$splice[0];

    orderedItems.splice(endIndex, 0, removed);
    return orderedItems;
  }

  function onDragEnd(result) {
    var _a;

    if (!result.destination || result.destination.index === result.source.index || !items) {
      return;
    }

    var reorderedItems = reorder(items, result.source.index, result.destination.index);
    setItems(_toConsumableArray(reorderedItems));
    (_a = options == null ? void 0 : options.onDragEnd) == null ? void 0 : _a.call(options, reorderedItems);
  }

  var DragAndDropList = function DragAndDropList(_ref) {
    var children = _ref.children;
    return (
      /* @__PURE__ */
      React.createElement(DragDropContext, {
        onDragEnd: onDragEnd
      },
      /* @__PURE__ */
      React.createElement(Droppable, {
        droppableId: "droppable"
      }, function (provided) {
        return (
          /* @__PURE__ */
          React.createElement("div", __spreadValues({
            ref: provided.innerRef
          }, provided.droppableProps), items == null ? void 0 : items.map(function (item, idx) {
            var draggableId = item.id.toString();
            return (
              /* @__PURE__ */
              React.createElement(Draggable, {
                index: idx,
                draggableId: draggableId,
                key: draggableId + "-" + idx,
                isDragDisabled: isDragDisabled
              }, function (provided2, snapshot) {
                return (
                  /* @__PURE__ */
                  React.createElement("div", __spreadProps(__spreadValues(__spreadValues({
                    ref: provided2.innerRef
                  }, provided2.draggableProps), provided2.dragHandleProps), {
                    "aria-label": "" + idx,
                    "data-testid": "draggable-item-" + draggableId
                  }), children({
                    item: item,
                    index: idx,
                    isDragging: snapshot.isDragging
                  }))
                );
              })
            );
          }), provided.placeholder)
        );
      }))
    );
  };

  return {
    DragAndDropList: DragAndDropList,
    items: items,
    setItems: setItems,
    isDragDisabled: isDragDisabled,
    setIsDragDisabled: setIsDragDisabled
  };
}

export { StrictModeDroppable, useDragAndDrop };